import { ChangeEvent, useEffect, useState } from "react";
import Badge from "react-bootstrap/Badge";import { LayoutTypes } from "@enums/layout-types";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import styles from "../update-organization-users-table-container.less";
import { UpdateOrganizationUsersTableData } from "../update-organization-users-table-container";
import { resources } from "@constants/hardcoded-strings";

type UpdateOrganizationUsersTableCredentialCellProps = {
    data: UpdateOrganizationUsersTableData;
    handleUserCredentialChange: (id: string, value: string) => void;
};

export const UpdateOrganizationUsersTableCredentialCell = (props: UpdateOrganizationUsersTableCredentialCellProps) => {
    const { data, handleUserCredentialChange } = props;

    // We need to keep and update the state of the cell normally
    const [value, setValue] = useState(data.credential)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = () => {
        handleUserCredentialChange(data.id, value);
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    // If the initialValue is changed external, sync it up with our state
    useEffect(() => {
        setValue(data.credential)
    }, [data.credential]);

    const isCredentialNew = data.initialCredential !== value;

    return (
        <div className={styles.credentialCell}>
            <InputFormGroup
                controlId={'update-organization-users-modal-credential-input'}
                automationId={'update-organization-users-modal-credential-input'}
                label={null}
                ariaLabel={null}
                className={styles.credentialInput}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                disabled={false}
                layout={LayoutTypes.COLUMN}
                isRequired={true}
            />
            <div className={styles.updateMessage} >
                <Badge pill bg={isCredentialNew ? "success" : "warning"}>
                    {isCredentialNew
                        ? resources.modals.updateOrganizationUsersModal.alerts.updated
                        : resources.modals.updateOrganizationUsersModal.alerts.notUpdated}
                </Badge>
            </div >
        </div>
    );
};